export const GET_CAR_MODEL_BEGIN = "GET_CAR_MODEL_BEGIN"
export const GET_CAR_MODEL_SUCCESS = "GET_CAR_MODEL_SUCCESS"